import React, { Component } from 'react';
import { connect } from 'react-redux';
import LazyImage from './../LazyImage';
import BadgePlaceholder from './BadgePlaceholder'
import {
    setBadge,
} from './../../actions/FormationActions';
import config from './../../config';
import common from './../../common';

class Badge extends Component {
    onBadgeClick = (badgeId) => {
        common.customTracking('Pick Badge');
        this.props.setBadge(badgeId)
    };

    render() {
        let badge = this.props.badge;
        let badgeID = badge.Id ? badge.Id : 0;
        let imgSrc = config.playerImgBase + `badges/${badgeID}.png`;
        const badgeClass = common.makeClasses({
            'si-badge-wrap': true,
            'si-selected': this.props.isSelected
        });
        return <div className={badgeClass} onClick={() => this.onBadgeClick(badgeID)}>
            <div className="si-badge-img">
                <LazyImage src={imgSrc} alt="" placeholder={<BadgePlaceholder />} />
            </div>
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setBadge: (badgeId) => dispatch(setBadge(badgeId)),
    };
};
export default connect(null, mapDispatchToProps)(Badge);


// WEBPACK FOOTER //
// ./src/components/onboarding/Badge.js